import React, { useRef } from "react"
import Button from "@src/components/core-button"
import Spinner from "@src/components/core-spinner"
import { UserContext } from "@src/context/user-context"
import FormInput from "../../reusable/forms/form-input"
import { useForm, FormProvider } from "react-hook-form"
import { validateEmail } from "@src/utils/validators"
import { FormActions } from "../../reusable/forms/auth-forms.styled"

function FormForgotPassword({ status, setStatus, switchToReset, children }) {
  const methods = useForm()
  const formRef = useRef()
  const { watch } = methods
  const email = watch("email")

  const handleProgrammaticSubmit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true }),
      )
    }
  }

  return (
    <FormProvider {...methods}>
      <p className="h2 forgot">Forgot password?</p>
      <p className="center">
        {status.success
          ? `The code has been sent to ${email}.`
          : `Enter your email and we'll send you a code to change your password in the next step.`}
      </p>
      <UserContext.Consumer>
        {({ recover }) => {
          const handleSubmit = ({ email }) => {
            setStatus({ ...status, pending: true })
            recover(email)
              .then(() => {
                setStatus({
                  success: true,
                  pending: false,
                  formMessage: null,
                })
              })
              .catch(error => {
                setStatus({
                  success: false,
                  pending: false,
                  formMessage: error,
                })
              })
          }
          return (
            <>
              {status.success ? null : (
                <form
                  ref={formRef}
                  onSubmit={methods.handleSubmit(handleSubmit)}
                >
                  <FormInput
                    label="Email"
                    name="email"
                    type="email"
                    validate={validateEmail()}
                  />
                </form>
              )}
              <FormActions>
                {status.formMessage && (
                  <p className="form-error">{status.formMessage}</p>
                )}
                {status.success ? (
                  <Button variant="rounded" onClick={switchToReset}>
                    Reset Password
                  </Button>
                ) : (
                  <Button
                    variant="rounded"
                    type="submit"
                    disabled={status.pending}
                    onClick={handleProgrammaticSubmit}
                  >
                    Submit
                    {status.pending && <Spinner color="white" size="sm" />}
                  </Button>
                )}
                {children}
              </FormActions>
            </>
          )
        }}
      </UserContext.Consumer>
    </FormProvider>
  )
}

export default FormForgotPassword
